import axios from "axios";

export async function applyServerDuplicateCheck(rows, apiAddr, dsid) {
  if (!apiAddr || !dsid) return rows;

  const checked = await Promise.all(
    rows.map(async (row) => {
      const pnum = String(row.pnum ?? "").trim();
      if (!pnum || row.rowStatus === "error") return row;

      try {
        const url = `${apiAddr}/get/verifypnum?id=${encodeURIComponent(pnum)}&dsid=${encodeURIComponent(dsid)}`;
        const res = await axios.get(url);
        const exists = Array.isArray(res.data) && res.data.length > 0;
        if (!exists) return row;

        return {
          ...row,
          rowStatus: "error",
          saveStatus: "duplicate",
          fieldStatus: { ...row.fieldStatus, pnum: "error" },
          fieldMessages: {
            ...row.fieldMessages,
            pnum: "동일 재난에 등록된 전화번호입니다",
          },
        };
      } catch {
        return row;
      }
    }),
  );

  return checked;
}
